module.exports = __webpack_public_path__ + "img/formulario_mobile.67add1bc.jpg";